export const weeklyAvgTeacherUsage = [
  {
    name: "REKHA RANI",
    emp_code: 79750,
    school: "1307 - Government Senior SecondarySchool Puthi",
    block: "Hansi",
    district: "Hisar",
    usage_in_mins: 236,
  },
  {
    name: "NAVAL SINGH",
    emp_code: 82756,
    school: "3071 - Government Senior Secondary School Kasni",
    block: "Salhawas",
    district: "Jhajjar",
    usage_in_mins: 195,
  },
  {
    name: "BHAGAT SINGH",
    emp_code: 94522,
    school: "3926 - Government Senior Secondary School Ganwari",
    block: "Nangal Choudhary",
    district: "Mahendragarh",
    usage_in_mins: 165,
  },
  {
    name: "POONAM",
    emp_code: 1026342,
    school: "875 - Government Girls Senior Secondary School Ferozepur",
    block: "Ferozepur Jhirka",
    district: "Nuh Mewat",
    usage_in_mins: 150,
  },
  {
    name: "ASHOK KUMAR",
    emp_code: 9063,
    school: "760 - Government Senior Secondary School Ghamroj",
    block: "Sohna",
    district: "Gurugram",
    usage_in_mins: 144,
  },
  {
    name: "AMIT WALIA",
    emp_code: 96716,
    school: "803 - Government High School Kurthala",
    block: "Nuh",
    district: "Nuh Mewat",
    usage_in_mins: 140,
  },
  {
    name: "RAJESH",
    emp_code: 60593,
    school: "2619 - Government Senior SecondarySchool Lookhi",
    block: "Nahar",
    district: "Rewari",
    usage_in_mins: 135,
  },
  {
    name: "Mr. SATYANARAYAN",
    emp_code: 22631,
    school: "2292 - Government Senior Secondary School Sajuma",
    block: "Kaithal",
    district: "Kaithal",
    usage_in_mins: 132,
  },
  {
    name: "ANIL",
    emp_code: 207629,
    school: "2072 - Government Senior Secondary School Asan",
    block: "Panipat",
    district: "Panipat",
    usage_in_mins: 129,
  },
  {
    name: "VINAY DAHIYA",
    emp_code: 201541,
    school: "1910 - Government High School Seikhpura Khasa",
    block: "Gharaunda",
    district: "Karnal",
    usage_in_mins: 120,
  },
];

export const weeklyAvgTeacherUsagelt1hrs = [
  {
    name: "SOMI",
    emp_code: 5013138,
    school: "2078 - Government Senior Secondary School Bhandari",
    block: "Madlauda",
    district: "Panipat",
    usage_in_mins: 58,
  },
  {
    name: "Mr. JAI PARKASH",
    emp_code: 12085,
    school: "914 - Government Senior Secondary School Subaseri",
    block: "Taoru",
    district: "Nuh Mewat",
    usage_in_mins: 58,
  },
  {
    name: "JYOTI",
    emp_code: 213572,
    school: "3153 - Government Senior SecondarySchool Dharana",
    block: "Beri",
    district: "Jhajjar",
    usage_in_mins: 57,
  },
  {
    name: "KAVITA DEVI",
    emp_code: 208258,
    school: "3605 - Government Senior Secondary School Bayanpur",
    block: "Sonipat",
    district: "Sonipat",
    usage_in_mins: 57,
  },
  {
    name: "KELA DEVI",
    emp_code: 4165,
    school: "184 - Government Senior Secondary School Mustafabad",
    block: "Mustafabad",
    district: "Yamunanagar",
    usage_in_mins: 56,
  },
  {
    name: "SARLA",
    emp_code: 207883,
    school: "333 - Government Girls Senior Secondary School",
    block: "Dadri",
    district: "Charkhi Dadri",
    usage_in_mins: 55,
  },
  {
    name: "SANTOSH DAGAR",
    emp_code: 62850,
    school: "2748 - Government Senior Secondary School Pehrawar",
    block: "Rohtak",
    district: "Rohtak",
    usage_in_mins: 55,
  },
  {
    name: "RAMESH KUMAR",
    emp_code: 5020788,
    school: "3076 - Government Senior Secondary School Dhakla",
    block: "Salhawas",
    district: "Jhajjar",
    usage_in_mins: 55,
  },
  {
    name: "RAJNI",
    emp_code: 1033047,
    school: "1922 - Government Senior SecondarySchool Ucha",
    block: "Karnal",
    district: "Karnal",
    usage_in_mins: 54,
  },
  {
    name: "RAVINDER KUMAR",
    emp_code: 61992,
    school: "432 - Government Senior SecondarySchool Leghan",
    block: "Kairu",
    district: "Bhiwani",
    usage_in_mins: 48,
  },
];

export const weeklyAvgTeacherUsagelt2hrs = [
  {
    name: "USHA RANI",
    emp_code: 94760,
    school: "3277 - Government Senior Secondary School Jakhal ",
    block: "Jakhal",
    district: "Fatehabad",
    usage_in_mins: 116,
  },

  {
    name: "KAMLA DEVI",
    emp_code: 203837,
    school: "3480 - Government Senior Secondary School Matindu",
    block: "Kharkhoda",
    district: "Sonipat",
    usage_in_mins: 109,
  },
  {
    name: "SATYA NARAIN SHARMA",
    emp_code: 27736,
    school: "3445 - Government Senior Secondary School Bhigan",
    block: "Ganaur",
    district: "Sonipat",
    usage_in_mins: 107,
  },
  {
    name: "PAWAN KUMAR",
    emp_code: 206559,
    school: "3871 - Government Senior Secondary School Dongra",
    block: "Kanina",
    district: "Mahendragarh",
    usage_in_mins: 106,
  },
  {
    name: "SANJAY TYAGI",
    emp_code: 4027,
    school: "190 - Government Senior Secondary School Radaur",
    block: "Radaur",
    district: "Yamunanagar",
    usage_in_mins: 105,
  },
  {
    name: "RATTAN LAL VERMA",
    emp_code: 83789,
    school: "3861 - Government Senior Secondary School Bairawas",
    block: "Mahendragarh",
    district: "Mahendragarh",
    usage_in_mins: 105,
  },
  {
    name: "RAKESH MOHAN",
    emp_code: 5018029,
    school: "2844 - Government Model Sanskriti Senior Secondary",
    block: "Sirsa",
    district: "Sirsa",
    usage_in_mins: 105,
  },
  {
    name: "SANJAY",
    emp_code: 5020629,
    school: "3472 - Government Girls Senior Secondary School",
    block: "Kathura",
    district: "Sonipat",
    usage_in_mins: 105,
  },
  {
    name: "SUBHASH CHAND",
    emp_code: 5020629,
    school: "4100 - Government Model Sanskriti Senior Secondary",
    block: "Mahendragarh",
    district: "Mahendragarh",
    usage_in_mins: 103,
  },
  {
    name: "NARENDER KUMAR",
    emp_code: 204224,
    school: "2184 - Government Senior Secondary School Bhunsla",
    block: "Guhla At Cheeka",
    district: "Kaithal",
    usage_in_mins: 94,
  },
];
